import React from 'react';
import { getFeatureFlags } from 'utils/feature-flags';
import { svgIcon } from 'utils/svg-icon';
import { Logo as WaitroseLogoIngredient } from '@johnlewispartnership/wtr-ingredients/ingredients/Logo';
import { prideLogo, prideLogoSmall } from './svgLogos';

import styles from './index.scss';

export interface WaitroseLogoProps {
  small?: boolean;
  className?: string;
}

function getLogo(small: boolean) {
  const { showPrideLogo } = getFeatureFlags();

  if (small) {
    return showPrideLogo ? (
      prideLogoSmall
    ) : (
      <WaitroseLogoIngredient optimised className={styles.logoSmall} clearSpace={false} />
    );
  }

  return showPrideLogo ? (
    prideLogo
  ) : (
    <WaitroseLogoIngredient className={styles.logoRegular} clearSpace={false} />
  );
}

const WaitroseLogo = ({ small = false, className }: WaitroseLogoProps) => {
  const Logo = svgIcon(getLogo(small), 'WaitroseLogo');

  // eslint-disable-next-line react-hooks/static-components
  return <Logo className={className} />;
};

export default WaitroseLogo;
